import {
    Navigate,
    useLocation,
    useNavigate,
    useParams,
} from 'react-router-dom';
import { useSelector } from 'react-redux';
import { OrderDetailView } from './OrdersTab';

/**
 * Route page for /number-blocks/orders/:orderId.
 *
 * The backend has no GET for a single order, so the clicked row is passed
 * via navigation state (`location.state.order`) and read here. On a refresh
 * or direct hit that state is gone — redirect back to the Orders tab rather
 * than show an empty page (same destination as "Back to Orders List").
 *
 * Orders are gated to the logged-in scope (requiredScope >= 60), matching the
 * Orders tab gate on the Number Blocks page. A lower-scope user who lands here
 * directly is redirected back rather than allowed to bypass that requirement.
 */
export default function OrderDetailsPage() {
    const navigate = useNavigate();
    const { state } = useLocation();
    const { orderId } = useParams();
    const { requiredScope } = useSelector((rootState) => rootState.login);

    const order = state?.order ?? null;

    if (requiredScope < 60 || !order) {
        return (
            <Navigate
                to="/number-blocks"
                state={{ openOrdersTab: true }}
                replace
            />
        );
    }

    return (
        <OrderDetailView
            order={order}
            orderId={orderId}
            onBack={() =>
                navigate('/number-blocks', { state: { openOrdersTab: true } })
            }
        />
    );
}
